export default __webpack_public_path__ + "static/media/ic-search.7b48a22c.svg";